import { createContext } from 'react'

import { PRICE_STATUS } from './PRICE_STATUS'
import { VAT_STATUS } from './VAT_STATUS'

export interface IToggleStatus {
  vatStatus: VAT_STATUS
  priceStatus: PRICE_STATUS
}

export const PriceContext = createContext({
  vatStatus: VAT_STATUS.HT,
  priceStatus: PRICE_STATUS.USER,
} as IToggleStatus)
